function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "30px",
    width: "30px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.517 392.517",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M70.359,147.507c6.012,0,10.925-4.848,10.925-10.925V71.03l22.885,8.145v72.081 c0,6.012,4.848,10.925,10.925,10.925h1.099c5.301,39.564,39.24,70.141,80.226,70.141s74.861-30.578,80.226-70.141h0.84 c6.012,0,10.925-4.848,10.925-10.925V79.176l37.495-13.317c10.214-3.879,9.051-17.907,0-20.558L199.846,0.63 c-2.392-0.84-4.913-0.84-7.24,0L66.739,45.301c-4.331,1.552-7.24,5.624-7.24,10.279v80.873 C59.434,142.594,64.283,147.507,70.359,147.507z M196.291,210.537c-28.897,0-53.01-20.881-58.182-48.291h116.364 C249.365,189.657,225.252,210.537,196.291,210.537z M266.432,140.396H125.955V86.933l66.586,23.661c2.392,0.84,4.848,0.84,7.24,0 l66.586-23.661v53.463H266.432z M196.226,22.545l93.285,33.099l-93.285,33.099l-93.285-33.099L196.226,22.545z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.109,162.246c5.107,27.41,29.22,48.291,58.182,48.291c28.897,0,53.01-20.881,58.182-48.291 H138.109z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M192.606,110.529L126.02,86.869v53.463h140.541V86.869l-66.715,23.661 C197.454,111.37,194.998,111.37,192.606,110.529z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#56ACE0"
    },
    points: "102.941,55.58 196.226,88.743 289.511,55.58 196.226,22.545  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M313.43,370.796c7.046-0.129,11.055-5.56,10.925-10.796v-33.358c0-8.016-4.461-15.451-11.766-19.394 c-35.556-19.265-75.83-29.737-116.428-30.513c-40.21,0.776-80.42,11.378-115.976,30.513c-7.24,3.943-11.766,11.378-11.766,19.394 v33.228c0,6.012,4.848,10.925,10.925,10.925"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M322.868,287.984c-38.659-20.881-82.295-32.323-126.836-33.164 c-44.024,0.84-87.725,12.283-126.319,33.164c-14.287,7.758-23.273,22.497-23.273,38.529v33.293 c0,18.036,14.675,32.711,32.711,32.711h234.214c17.842,0,32.711-14.352,32.711-32.711v-33.293 C346.141,310.545,337.22,295.677,322.868,287.984z M324.355,359.871c0.129,5.301-3.879,10.667-10.925,10.796h-24.954v-17.519 c0-6.012-4.848-10.925-10.925-10.925c-6.077,0-10.99,4.848-10.99,10.925v17.648H125.955v-17.648c0-6.012-4.848-10.925-10.925-10.925 c-6.077,0-10.925,4.848-10.925,10.925v17.648H79.151c-6.012,0-10.925-4.848-10.925-10.925v-33.293 c0-8.016,4.461-15.451,11.766-19.394c35.556-19.265,75.83-29.737,115.976-30.513c40.663,0.776,80.873,11.378,116.428,30.513 c7.24,3.943,11.766,11.378,11.766,19.394v33.293H324.355z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.63c160e115642eb66303cb3cd490e7d8.svg";
export { ForwardRef as ReactComponent };